export const getCustomerPaymentList = state => {
    return state.list
}

export const getCustomerPaymentDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/customerPayment/getters.js